import { RouteName, TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { useLocalizeText } from '@mews/framework';
import { canCurrentProfileViewSensitiveReports } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { isCurrentEnterpriseAnalyticsIntegrationEnabled } from '@mews-commander/legacy-entities/src/selectors';
import { useCommanderSelector } from '@mews-commander/utils';
import { mapAnalyticsTypeTextKey } from '../../../../powerBi/utils';
import AnalyticsType from '../../../../powerBi/enums/analyticsType';
import { useNavigationSearchResult } from './useNavigationSearchResult';
import { AssistantNavigation } from './AssistantNavigation';
import { useNavigationPath } from './useNavigationPath';

export const useAnalyticNavigation = (): AssistantNavigation[] => {
    const isAnalyticsIntegrationEnabled = useCommanderSelector((state) =>
        isCurrentEnterpriseAnalyticsIntegrationEnabled(state, {})
    );
    const isMewsAnalyticsAvailable =
        useCommanderSelector<boolean>(canCurrentProfileViewSensitiveReports) && isAnalyticsIntegrationEnabled;
    const localizeText = useLocalizeText();
    const parentPath = `${localizeText({ textKey: TextKey.Analytics })}${UnicodeEntity.Space}${
        UnicodeEntity.ForwardSlash
    }${UnicodeEntity.Space}`;

    const managerResult = useNavigationSearchResult(
        RouteName.AnalyticsIndex,
        mapAnalyticsTypeTextKey[AnalyticsType.Manager],
        {
            query: { type: AnalyticsType.Manager },
        },
        useNavigationPath(parentPath, mapAnalyticsTypeTextKey[AnalyticsType.Manager]),
        'managerId'
    );
    const financialResult = useNavigationSearchResult(
        RouteName.AnalyticsIndex,
        mapAnalyticsTypeTextKey[AnalyticsType.Financial],
        {
            query: { type: AnalyticsType.Financial },
        },
        useNavigationPath(parentPath, mapAnalyticsTypeTextKey[AnalyticsType.Financial]),
        'financialId'
    );
    const outletResult = useNavigationSearchResult(
        RouteName.AnalyticsIndex,
        mapAnalyticsTypeTextKey[AnalyticsType.Outlet],
        {
            query: { type: AnalyticsType.Outlet },
        },
        useNavigationPath(parentPath, mapAnalyticsTypeTextKey[AnalyticsType.Outlet]),
        'outletId'
    );
    const pickupResult = useNavigationSearchResult(
        RouteName.AnalyticsIndex,
        mapAnalyticsTypeTextKey[AnalyticsType.Pickup],
        {
            query: { type: AnalyticsType.Pickup },
        },
        useNavigationPath(parentPath, mapAnalyticsTypeTextKey[AnalyticsType.Pickup]),
        'pickupId'
    );

    return isMewsAnalyticsAvailable ? [managerResult, financialResult, outletResult, pickupResult] : [];
};
